export default {
  getShopItemList: state => state.shopItemList,
  getBuyMemorialList: state => state.buyMemorialItemList,
  getCategoryShopList: state => state.categoryShopList,
  getUserItemCondition: state => state.userItemCondition,
  getUserPageInfo: state => state.userPageInfo,
  getUserItemList: state => state.userItemList,
  getList: state => state.list
};
